/**
 * Starter Tooltip — wraps Mantine's `<Tooltip>` so its surface paints
 * the design's high-contrast charcoal pill (warm-neutral 700 / white) per
 * preview/comp-toasts.html.
 *
 * Floating arrow & openDelay come from Mantine defaults; styling overlay
 * lives in Tooltip.module.css.
 */
import { forwardRef } from 'react';
import {
  Tooltip as MantineTooltip,
  type TooltipProps as MantineTooltipProps,
} from '@mantine/core';
import styles from './Tooltip.module.css';

export interface TooltipProps extends MantineTooltipProps {}

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(
  { classNames, openDelay, withArrow = true, ...rest },
  ref,
) {
  const existing = (classNames ?? {}) as {
    tooltip?: string;
    arrow?: string;
  };
  const mergedClassNames = {
    ...existing,
    tooltip: [styles.tooltip, existing.tooltip].filter(Boolean).join(' '),
    arrow: [styles.arrow, existing.arrow].filter(Boolean).join(' '),
  };
  return (
    <MantineTooltip
      ref={ref}
      classNames={mergedClassNames}
      openDelay={openDelay ?? 200}
      withArrow={withArrow}
      {...rest}
    />
  );
});
